import { useMutation } from '@tanstack/react-query';
import { POST, POST_DESTROT_PRODUCT } from '../../../../services';
import { openAlert } from '../../../../components/alert/useAlert';

export const useDeleteProduct = ({ onSuccessCallBack }) =>
  useMutation({
    mutationFn: async ({ productId, remark }) => {
      const response = await POST(POST_DESTROT_PRODUCT(), {
        productId,
        remark,
      });

      if (onSuccessCallBack) onSuccessCallBack(response);

      return response;
    },
    onSuccess: () => {
      openAlert({ model: 'message', type: 'success', message: 'ลบข้อมูล Product List สำเร็จ' });
    },
  });
